import { Text } from '@cencosud-cencommerce/paris-uikit';

import { SelectAnotherDate } from '@/Application/Components/DeliveryDateSelect/SelectAnotherDate';
import type { GtmGroupsData } from '@/modules/shared/utils/gtmEvents/types';

import DeliveryDateItem, {
  type DeliveryDateItemProps
} from './DeliveryDateItem/DeliveryDateItem';

export interface DeliveryDateSelectProps {
  title: string;
  dateList?: DeliveryDateItemProps[];
  onChooseDate: VoidFunction;
  gtmData?: GtmGroupsData;
  isSelectAnotherDateAvailable?: boolean;
}

const DeliveryDateSelect: React.FC<DeliveryDateSelectProps> = ({
  title,
  dateList,
  onChooseDate,
  isSelectAnotherDateAvailable,
  gtmData
}) => {
  const isOnlyOption = dateList?.length === 1;

  return (
    <div
      className="co-flex co-flex-col co-w-full"
      data-testid="co-delivery-date-selector"
    >
      <div className="co-pt-6 co-px-4 co-pb-4">
        <Text variant="body2" weight={600}>
          {title}
        </Text>
      </div>
      <div>
        {dateList?.map((date, index) => (
          <DeliveryDateItem
            {...date}
            key={index}
            gtmData={gtmData}
            onlyOption={isOnlyOption}
          />
        ))}
      </div>
      {isSelectAnotherDateAvailable && (
        <SelectAnotherDate onChooseDate={onChooseDate} gtmData={gtmData} />
      )}
    </div>
  );
};

export default DeliveryDateSelect;
